import { Divider } from 'libs/ui';

import { AuthorizationAndSessionSettings } from './AuthorizationAndSessionSettings';
import { PasswordSettings } from './PasswordSettings';

export const AccountingSystemFormContent = () => (
  <div>
    <PasswordSettings />

    <Divider />

    <AuthorizationAndSessionSettings />
  </div>
);
